import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e608173"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitoring-days-table-info__user-info" }
const _hoisted_2 = ["onClick"]

import { TirPmTableTr, TirPmTableTd } from 'tir-pm-table';
import { computed, PropType } from 'vue';
import PerformerTaskDaysResponseItemsModel from '../../models/PerformerTaskDaysResponseItemsModel';
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmIconView,
  TirPmPopover,
  TirPmTooltipElement,
} from 'tir-components';
import { RouterLink, useRouter } from 'vue-router';
import DailySummariesModel from '../../models/DailySummariesModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-days-table-info',
  props: {
  /**Фильтр мониторинга */
  filter: { type: Object as PropType<MonitoringHeaderFilterModel> },
  /**Данные юзера */
  dataUsers: { type: Array as PropType<PerformerTaskDaysResponseItemsModel[]> },
  /**Массив с ширинами колонок */
  columnWidths: { type: Array as PropType<string[]>, default: () => [] },
  /**Ежедневные сводки */
  dailySummaries: { type: Array as PropType<DailySummariesModel[]> },
},
  emits: ["EventOpenTasksListDrawer"],
  setup(__props, { emit }) {

const props = __props;





/**Роутер */
const router = useRouter();

/**Перейти к задачам пользователя */
const routeToUserTasks = (userId: number) => {
  return router.resolve({
    name: 'user-tasks',
    params: { userId },
  }).href;
};

/** Получить общее время */
const getTotalTime = (time: DailySummariesModel[]) => {
  let hours = time.reduce((acc, t) => acc + parseInt(String(t.TotalTimeSpent)), 0);
  let totalMinutes = time.reduce((acc, t) => acc + (t.TotalTimeSpent % 1), 0) * 100;

  if (totalMinutes > 60) {
    hours += totalMinutes / 60;
    totalMinutes = totalMinutes % 60;
  }

  return `${hours.toFixed(0).padStart(2, '0')}:${totalMinutes.toFixed(0).padStart(2, '0')}`;
};

/**Отфильтрованные колонки */
const filteredDailySummaries = computed(() => {
  const uniqueDates = new Set();

  return props.dailySummaries?.filter((item) => {
    const formattedDate = new Date(item.Date).toISOString().split('T')[0];

    if (uniqueDates.has(formattedDate)) {
      return false;
    }

    uniqueDates.add(formattedDate);
    return true;
  });
});

/**Данные о дне */
const computedDayData = computed(() => {
  const sortedData = filteredDailySummaries.value
    .map((daily) => {
      const dayData = getDayWeek(daily.Date);
      return {
        ...daily,
        isWeekend: dayData.isWeekend,
        day: dayData.day,
      };
    })
    .sort((a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime());

  return sortedData;
});

/**Получить день недели */
const getDayWeek = (date: Date) => {
  let newDate = new Date(date);
  newDate.setDate(newDate.getDate());

  const dayOfWeek = newDate.getDay();
  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

  return {
    day: newDate.toLocaleDateString('ru-RU', { weekday: 'short' }).toUpperCase(),
    isWeekend,
  };
};

/**Открытие шторки с задачами */
const openTasksListDrawer = (user: PerformerTaskDaysResponseItemsModel, daily: any) => {
  emit('EventOpenTasksListDrawer', user, daily);
};

/**Форматирование времени */
const formatTime = (time: number, finalTime?: boolean) => {
  const workTime = time.toFixed(2);

  const hours = workTime.split('.')[0].padStart(2, '0');
  const minutes = workTime.split('.')[1].padStart(2, '0');

  if (finalTime) {
    return workTime.replace('.', 'ч ') + 'м';
  }
  return `${hours}:${minutes}`;
};

/**Получает отформатированное время, затраченное пользователем за указанный день */
const getFormattedTime = (user, daily) => {
  const timeSpent = user.DailySummaries.find(
    (d) =>
      new Date(d.Date).toISOString().split('T')[0] ===
      new Date(daily.Date).toISOString().split('T')[0],
  )?.TotalTimeSpent;
  return timeSpent ? formatTime(timeSpent) : '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataUsers, (user) => {
    return (_openBlock(), _createBlock(_unref(TirPmTableTr), {
      class: "monitoring-days-table-info__rows",
      columns: __props.columnWidths
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(TirPmTableTd), {
          isLeftBorder: false,
          class: "monitoring-days-table-info__data"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmIconView), {
              size: 24,
              isRounded: "",
              isBordered: false,
              colorCode: user.UsersData.AvatarColor,
              imageLoadUrl: user.UsersData.Foto
            }, {
              mainSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.UsersData.LastName[0]) + _toDisplayString(user.UsersData.FirstName[0]), 1)
              ]),
              _: 2
            }, 1032, ["colorCode", "imageLoadUrl"]),
            _createVNode(_unref(TirPmTooltipElement), { class: "monitoring-days-table-info__data-user" }, {
              default: _withCtx(() => [
                _createVNode(_unref(RouterLink), {
                  class: "monitoring-days-table-info__data-user",
                  to: routeToUserTasks(user.UsersData.Id)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(user.UsersData.LastName) + " " + _toDisplayString(user.UsersData.FirstName) + " " + _toDisplayString(user.UsersData.MiddleName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(user.UsersData.LastName) + " " + _toDisplayString(user.UsersData.FirstName) + " " + _toDisplayString(user.UsersData.MiddleName), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024),
        _createVNode(_unref(TirPmTableTd), { class: "monitoring-days-table-info__data-general-hours" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(getTotalTime(user.DailySummaries)), 1)
          ]),
          _: 2
        }, 1024),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedDayData.value, (daily) => {
          return (_openBlock(), _createBlock(_unref(TirPmTableTd), {
            class: _normalizeClass(["monitoring-days-table-info__data-day-work-block", { 'weekend-day': daily.isWeekend }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _withModifiers(($event: any) => (openTasksListDrawer(user, daily)), ["stop"]),
                class: "monitoring-days-table-info__data-day-work"
              }, _toDisplayString(getFormattedTime(user, daily)), 9, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 256))
      ]),
      _: 2
    }, 1032, ["columns"]))
  }), 256))
}
}

})